import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="bg-light">

      {/* Hero Section */}
      <section className="bg-gradient-left-right text-white py-5 text-center">
        <h1 className="display-4 font-weight-bold mb-4">
          Secure Your Notes with eNotebook
        </h1>
        <p className="lead mb-4">
          Store your notes securely, access them anytime, and organize your digital life with ease.
        </p>
        <div className="d-flex justify-content-center gap-4">
          <Link to="/login" className="btn btn-light btn-lg px-4 py-3 rounded-pill">
            Login
          </Link>
          <i className="fa-solid fa-book-atlas d-flex align-items-center" style={{fontSize: "35px"}}></i>
          <Link to="/signup" className="btn btn-outline-light btn-lg px-4 py-3 rounded-pill">
            Sign Up
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-gradient-left-right text-center">
        <h2 className="display-4 text-white mb-5">Why Choose eNotebook?</h2>
        <div className="container">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div className="col">
              <div className="card shadow-sm border-0 rounded-lg">
                <div className="card-body">
                  <h5 className="card-title text-primary">End-to-End Encryption</h5>
                  <p className="card-text text-muted">
                    Your notes are encrypted with the highest level of security, ensuring privacy and peace of mind.
                  </p>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm border-0 rounded-lg">
                <div className="card-body">
                  <h5 className="card-title text-primary">Easy Organization</h5>
                  <p className="card-text text-muted">
                    Categorize and search your notes effortlessly, keeping everything organized and accessible.
                  </p>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card shadow-sm border-0 rounded-lg">
                <div className="card-body">
                  <h5 className="card-title text-primary">Access Anywhere</h5>
                  <p className="card-text text-muted">
                    Access your notes from any device, anytime, and from anywhere in the world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default LandingPage;
